import { render, staticRenderFns } from "./former.vue?vue&type=template&id=7d8cb1f9&scoped=true&"
import script from "./former.vue?vue&type=script&lang=js&"
export * from "./former.vue?vue&type=script&lang=js&"
import style0 from "./former.vue?vue&type=style&index=0&id=7d8cb1f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8cb1f9",
  null
  
)

export default component.exports